<div id="page-container">
  <div id="content-wrap">
    <div class="fullScreen">
      <headband [accountName]="accountName" [maxVoters]="maxVoters" [hasHotline]="hasHotline"
        (hotlinePopupChange)="hotlinePopup = $event" (optionsPopupChange)="changeSubscription()"
        (buyPopupEvent)="shouldBuyCredits = $event"></headband>
    </div>

    <div class="flex content-evenly">
      <div>
        <img src="assets/v8te.png" id="logo">
      </div>
      <main class="w-70p flex flex-column" style="height: 100vh;">
        <div class="title-holder mt-40 p-20 mt-" id="pap-header" style="width: 100%; box-sizing: border-box;">
          <app-pap-header style="width: 100%;" [step]="currentStep"></app-pap-header>
        </div>
        <div *ngIf="pollCreationStep" class="title-holder p-20 bg-pastel-blue w-full border-box" id="pap-header"
          style="box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); position: relative; z-index: 1;">
          <div class="flex align-items-center gap-10">
            <div class="flex flex-column align-items-center gap-10">
              <p class="no-margin flex bold white bg-light-blue align-items-center content-center"
                style="width: 40px; height: 40px; border-radius: 50%;">
                3
              </p>
            </div>
            <div>
              <div class="flex gap-10 mb-10">
                <p class="no-margin light-blue bold">Création du scrutin</p>
                <!-- <div class="flex align-items-center gap-10"> -->
                <p [style.background-color]="1 <= step ? '#1990FF' : '#E2E8F0'"
                  [style.color]="1 <= step ? '#FFFFFF' : '#64748B'"
                  class="no-margin flex bold align-items-center content-center text-xs"
                  style="width: 20px; height: 20px; border-radius: 50%;">
                  1</p>
                <p [style.background-color]="2 <= step ? '#1990FF' : '#E2E8F0'"
                  [style.color]="2 <= step ? '#FFFFFF' : '#64748B'"
                  class="no-margin flex bold align-items-center content-center text-xs"
                  style="width: 20px; height: 20px; border-radius: 50%;">
                  2</p>
                <p [style.background-color]="3 <= step ? '#1990FF' : '#E2E8F0'"
                  [style.color]="3 <= step ? '#FFFFFF' : '#64748B'"
                  class="no-margin flex bold align-items-center content-center text-xs"
                  style="width: 20px; height: 20px; border-radius: 50%;">
                  3</p>
                <p [style.background-color]="4 <= step ? '#1990FF' : '#E2E8F0'"
                  [style.color]="4 <= step ? '#FFFFFF' : '#64748B'"
                  class="no-margin flex bold align-items-center content-center text-xs"
                  style="width: 20px; height: 20px; border-radius: 50%;">
                  4</p>
                <!-- </div> -->
              </div>
              <p class="no-margin"><span class="bold dark-blue">Paramétrer mon scrutin : </span><span
                  class="dark-gray">Définissez ou ajustez les paramètres structurants de votre élection.</span></p>
            </div>
          </div>
        </div>

        <div *ngIf="assessorClosingStep" class="title-holder p-20 bg-pastel-blue w-full border-box" id="pap-header"
          style="box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); position: relative; z-index: 1;">
          <div class="flex align-items-center gap-10">
            <div class="flex flex-column align-items-center gap-10">
              <p class="no-margin flex bold white bg-light-blue align-items-center content-center"
                style="width: 40px; height: 40px; border-radius: 50%;">
                4
              </p>
            </div>
            <div>
              <div class="flex gap-10 mb-10">
                <p class="no-margin light-blue bold">Scrutin à blanc</p>
                <!-- <div class="flex align-items-center gap-10"> -->
                <p [style.background-color]="1 <= assessorStep ? '#1990FF' : '#E2E8F0'"
                  [style.color]="1 <= assessorStep ? '#FFFFFF' : '#64748B'"
                  class="no-margin flex bold align-items-center content-center text-xs"
                  style="width: 20px; height: 20px; border-radius: 50%;">
                  1</p>
                <p [style.background-color]="2 <= assessorStep ? '#1990FF' : '#E2E8F0'"
                  [style.color]="2 <= assessorStep ? '#FFFFFF' : '#64748B'"
                  class="no-margin flex bold align-items-center content-center text-xs"
                  style="width: 20px; height: 20px; border-radius: 50%;">
                  2</p>
              </div>
              <p class="no-margin"><span class="bold dark-blue">Processus séquentiel : </span><span
                  class="dark-gray">Guidez votre scrutin blanc étape par étape : clefs de scellement, invitations, suivi
                  des votes.</span></p>
            </div>
          </div>
        </div>
        <!-- <button (click)="logDetails()" style="position: fixed; z-index: 1000;">Log Details</button> -->
        <div id="pap-body" style="flex: 1; overflow: auto;">
          <!-- PAP STEPS -->
          <app-pap-body *ngIf="papCreationStep" [papValues]="papValues" (papValuesChange)="onPapValuesChange($event)"
            (numberOfCollegesChanges)="updateColleges()" (toCerfa)="goToCerfaCreation()"></app-pap-body>
          <app-pap-verification *ngIf="papVerificationStep" [(papValues)]="papValues"
            [validatedCategoriesCount]="validatedCategoriesCount"
            (validatedComponents)="onValidatedComponentsChange($event)" (editRequested)="onEditRequested($event)"
            [(expandedView)]="expandedView" [verificationPercentage]="verificationPercentage"></app-pap-verification>
          <app-pap-completed *ngIf="papCompletedStep || cerfaCompletedStep"
            (toPapVerification)="backToPapVerification()" (cerfaCreation)="goToCerfaCreation()" [step]="currentStep"
            (toCerfaVerification)="backToCerfaVerification()" (toPollCreation)="goToPollCreation()"
            (toCerfaCreation)="goToCerfaCreation()"></app-pap-completed>

          <!-- CERFA STEPS -->
          <app-cerfa-body *ngIf="cerfaCreationStep" [(papValues)]="papValues"
            (papValuesChange)="onCerfaValuesChange($event)" (toPollCreation)="goToPollCreation()"></app-cerfa-body>
          <app-cerfa-verification *ngIf="cerfaVerificationStep" [(papValues)]="papValues"
            [validatedCategoriesCount]="validatedCerfaCategoriesCount" (editRequested)="onCerfaEditRequested($event)"
            (validatedComponents)="onCerfaValidatedComponentsChange($event)"
            [verificationPercentage]="cerfaVerificationPercentage"></app-cerfa-verification>

          <!-- POLL CREATION STEP -->
          <app-cse-poll-creation *ngIf="pollCreationStep" [(papValues)]="papValues" [(poll)]="currentPoll"
            (papValuesChange)="stepCompleted($event)" [step]="step" (confirmVoters)="votersReady()"
            (numberOfCollegesChanges)="updateColleges()" [(unions)]="unions"
            (onUnionImageChange)="saveUnionImage($event)" (assessorsValidated)="accessorValidated()"
            (onElectionImageChange)="handleElectionImage($event)" [votersConfirmed]="votersListReady"
            [areAssessorsValidated]="areAssessorsValidated" [(collegeCandidatesData)]="collegeCandidatesData"
            [(validatedColleges)]="validatedColleges"></app-cse-poll-creation>

          <div *ngIf="assessorsInvitesLoader">
            <vc-loader messageToTheUser="Invitation des assesseurs en cours, cela peut prendre quelques secondes...">
            </vc-loader>
          </div>

          <app-assessors-closing *ngIf="assessorClosingStep" [currentStep]="assessorStep"
            [assessors]="currentPoll.assessors" (inviteAssessorsEvent)="initAssessorsLaunch()"
            [remainingAssessors]="remainingAssessors" (inviteAssessorsVoteEvent)="initAssessorsVote()"
            [assessorQuorum]="assessorTestQuorum" (closeAssessorsVoteEvent)="closeAssessorsVote()"
            (validateTestVoteEvent)="validateTestVote($event)" [inactiveAssessors]="inactiveAssessors"
            [isTestVoteOpen]="isTestVoteOpen" [unsealStepReady]="unsealStepReady" (updateAssessorEvent)="updateAssessor($event)"
            (relaunchAssessorEvent)="relaunchAssessor($event)" [unsealedAssessors]="unsealedAssessors"
            [isBallotUnsealed]="isBallotUnsealed" [rounds]="currentPoll.rounds" [testStepStatus]="testStepStatus">
          </app-assessors-closing>

          <app-pap-ready *ngIf="pollReadyStep" (toPollPlannedEvent)="goToPollPlanned()"></app-pap-ready>
        </div>
        <div *ngIf="cerfaCreationStep" class="flex content-between p-20" id="cerfa-creation-footer"
          style="border-top: solid 1px #F0F5FF;">
          <!-- <button class="edit-button" (click)="goToPapCreation()">
            <img src="assets/sheet-icon.svg" alt="">
            Retour au paramètrage du PAP
          </button> -->
          <v8te-active-button *ngIf="step == 1" [buttonText]="'Retour au paramètrage du PAP'" [primaryColor]="'#FFFFFF'"
            [textPrimaryColor]="'#2B2D67'" [iconPosition]="'left'" [border]="'solid 1px #2B2D67'"
            [icon]="'assets/sheet-icon.svg'" [iconAlt]="'arrow icon'" (click)="goToPapCreation()" [height]="'40px'"
            [minWidth]="'120px'" [width]="'120px'"></v8te-active-button>

          <!-- <button *ngIf="cerfaVerificationReady" class="edit-button" (click)="goToCerfaVerification()">
            <img src="assets/sheet-icon.svg" alt="">
            Passer à la validation des données CERFA
          </button>

          <button *ngIf="!cerfaVerificationReady" class="disabled-action-button">
            <img src="assets/sheet-icon.svg" alt="">
            Passer à la validation des données CERFA
          </button> -->

          <v8te-active-button [icon]="'assets/arrow-right-white.svg'"
            [buttonText]="'Passer à la validation des données CERFA'" [primaryColor]="'#1990FF'"
            [textPrimaryColor]="'#FFFFFF'" [secondaryColor]="'#1990FF'" [textSecondaryColor]="'#FFFFFF'"
            [iconPosition]="'right'" [border]="'none'" [active]="cerfaVerificationReady" [iconAlt]="'arrow icon'"
            (click)="cerfaVerificationReady && goToCerfaVerification()" [height]="'40px'" [minWidth]="'120px'"
            [width]="'120px'"></v8te-active-button>
        </div>

        <div *ngIf="cerfaVerificationStep" class="flex content-between p-20" id="cerfa-verification-footer"
          style="border-top: solid 1px #F0F5FF;">
          <v8te-active-button *ngIf="step == 1" [buttonText]="'Enregistrer et quitter'" [primaryColor]="'#FFFFFF'"
            [textPrimaryColor]="'#2B2D67'" [iconPosition]="'left'" [border]="'solid 1px #2B2D67'"
            [icon]="'assets/sheet-icon.svg'" [iconAlt]="'arrow icon'" (click)="goToPapCreation()" [height]="'40px'"
            [minWidth]="'120px'" [width]="'120px'"></v8te-active-button>
          <v8te-active-button [icon]="'assets/arrow-right-white.svg'" [buttonText]="'Valider les données CERFA'"
            [primaryColor]="'#1990FF'" [textPrimaryColor]="'#FFFFFF'" [secondaryColor]="'#1990FF'"
            [textSecondaryColor]="'#FFFFFF'" [iconPosition]="'right'" [border]="'none'" [iconAlt]="'arrow icon'"
            [active]="validatedCerfaCategoriesCount == cerfaVerifiedComponents.length"
            (click)="validatedCerfaCategoriesCount == cerfaVerifiedComponents.length && confirmCerfa()"
            [height]="'40px'" [minWidth]="'120px'" [width]="'120px'"></v8te-active-button>
        </div>

        <div *ngIf="pollCreationStep" class="flex content-between p-20" id="poll-creation-footer"
          style="border-top: solid 1px #F0F5FF;">
          <div class="flex gap-20">
            <v8te-active-button *ngIf="step == 1" [buttonText]="'Retour au données CERFA'" [primaryColor]="'#FFFFFF'"
              [textPrimaryColor]="'#2B2D67'" [iconPosition]="'left'" [border]="'solid 1px #2B2D67'"
              [icon]="'assets/arrow-left.svg'" [iconAlt]="'arrow icon'" (click)="goToCerfaCreation()" [height]="'40px'"
              [minWidth]="'120px'" [width]="'120px'"></v8te-active-button>

            <v8te-active-button *ngIf="step == 2" [buttonText]="'Retour aux paramètres'" [primaryColor]="'#FFFFFF'"
              [textPrimaryColor]="'#2B2D67'" [iconPosition]="'left'" [border]="'solid 1px #2B2D67'"
              [icon]="'assets/arrow-left.svg'" [iconAlt]="'arrow icon'" (click)="goToPreviousCreationStep()"
              [height]="'40px'" [minWidth]="'120px'" [width]="'120px'"></v8te-active-button>

            <v8te-active-button *ngIf="step == 3" [buttonText]="'Retour mode d\'envoi et sécurité'"
              [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#2B2D67'" [iconPosition]="'left'"
              [border]="'solid 1px #2B2D67'" [icon]="'assets/arrow-left.svg'" [iconAlt]="'arrow icon'"
              (click)="goToPreviousCreationStep()" [height]="'40px'" [minWidth]="'120px'"
              [width]="'120px'"></v8te-active-button>

            <v8te-active-button *ngIf="step == 4" [buttonText]="'Retour à la liste électorale'"
              [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#2B2D67'" [iconPosition]="'left'"
              [border]="'solid 1px #2B2D67'" [icon]="'assets/arrow-left.svg'" [iconAlt]="'arrow icon'"
              (click)="goToPreviousCreationStep()" [height]="'40px'" [minWidth]="'120px'"
              [width]="'120px'"></v8te-active-button>

            <v8te-active-button [buttonText]="'Enregistrer'" [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#2B2D67'"
              [iconPosition]="'left'" [border]="'solid 1px #2B2D67'" [icon]="'assets/floppy-icon.svg'"
              [iconAlt]="'arrow icon'" [height]="'40px'" [minWidth]="'120px'" [width]="'120px'"></v8te-active-button>

          </div>
          <v8te-active-button *ngIf="pollCreationStep && step == 1" [icon]="'assets/arrow-right-white.svg'"
            [buttonText]="'Continuer le paramétrage ' + (step + 1) + '/4'" [primaryColor]="'#1990FF'"
            [textPrimaryColor]="'#FFFFFF'" [secondaryColor]="'#1990FF'" [textSecondaryColor]="'#FFFFFF'"
            [iconPosition]="'right'" [border]="'none'" [active]="stepOneDone" [iconAlt]="'arrow icon'"
            (click)="stepOneDone && goToNextCreationStep()" [height]="'40px'" [minWidth]="'120px'"
            [width]="'120px'"></v8te-active-button>

          <v8te-active-button *ngIf="pollCreationStep && step == 2" [icon]="'assets/arrow-right-white.svg'"
            [buttonText]="'Continuer le paramétrage ' + (step + 1) + '/4'" [primaryColor]="'#1990FF'"
            [textPrimaryColor]="'#FFFFFF'" [secondaryColor]="'#1990FF'" [textSecondaryColor]="'#FFFFFF'"
            [iconPosition]="'right'" [border]="'none'" [active]="stepTwoDone" [iconAlt]="'arrow icon'"
            (click)="stepTwoDone && goToNextCreationStep()" [height]="'40px'" [minWidth]="'120px'"
            [width]="'120px'"></v8te-active-button>

          <v8te-active-button *ngIf="pollCreationStep && step == 3 && !votersListReady"
            [buttonText]="'Continuer le paramétrage ' + (step + 1) + '/4'" [primaryColor]="'#1990FF'"
            [textPrimaryColor]="'#FFFFFF'" [secondaryColor]="'#1990FF'" [textSecondaryColor]="'#FFFFFF'"
            [iconPosition]="'right'" [border]="'none'" [icon]="'assets/arrow-right.svg'" [iconAlt]="'arrow icon'"
            (click)="votersListReady && goToNextCreationStep()" [height]="'40px'" [minWidth]="'120px'" [width]="'120px'"
            [active]="votersListReady && goToNextCreationStep()"></v8te-active-button>

          <v8te-active-button *ngIf="pollCreationStep && step == 3 && votersListReady"
            [buttonText]="'Continuer le paramétrage ' + (step + 1) + '/4'" [primaryColor]="'#1990FF'"
            [textPrimaryColor]="'#FFFFFF'" [secondaryColor]="'#1990FF'" [textSecondaryColor]="'#FFFFFF'"
            [iconPosition]="'right'" [border]="'none'" [icon]="'assets/arrow-right.svg'" [iconAlt]="'arrow icon'"
            (click)="votersListReady && goToNextCreationStep()" [height]="'40px'" [minWidth]="'120px'" [width]="'120px'"
            [active]="votersListReady"></v8te-active-button>
          <v8te-active-button *ngIf="pollCreationStep && step == 4" [buttonText]="'Créer le scrutin'"
            [primaryColor]="'#1990FF'" [textPrimaryColor]="'#FFFFFF'" [secondaryColor]="'#1990FF'"
            [textSecondaryColor]="'#FFFFFF'" [iconPosition]="'right'" [border]="'none'"
            [icon]="'assets/arrow-right.svg'" [iconAlt]="'arrow icon'" (click)="createPoll()" [height]="'40px'"
            [minWidth]="'120px'" [width]="'120px'" [active]="areAssessorsValidated"></v8te-active-button>
        </div>

        <div *ngIf="assessorClosingStep" class="flex content-between p-20" id="poll-creation-footer">
          <div class="flex gap-20">
            <v8te-active-button [buttonText]="'retour'" [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#2B2D67'"
              [iconPosition]="'left'" [border]="'solid 1px #2B2D67'" [icon]="'assets/arrow-left.svg'"
              [iconAlt]="'arrow icon'" [height]="'40px'" [minWidth]="'120px'" [width]="'120px'"></v8te-active-button>

            <v8te-active-button [buttonText]="'Enregistrer et quitter'" [primaryColor]="'#FFFFFF'"
              [textPrimaryColor]="'#2B2D67'" [iconPosition]="'left'" [border]="'solid 1px #2B2D67'"
              [icon]="'assets/floppy-icon.svg'" [iconAlt]="'floppy icon'" [height]="'40px'" [minWidth]="'120px'"
              [width]="'120px'"></v8te-active-button>
          </div>

          <v8te-active-button *ngIf="assessorStep === 1" [buttonText]="'Déscellement et vérification des résultats'"
            [primaryColor]="'#1990FF'" [textPrimaryColor]="'#FFFFFF'" [secondaryColor]="'#1990FF'"
            [textSecondaryColor]="'#FFFFFF'" [iconPosition]="'right'" [border]="'none'"
            [icon]="'assets/arrow-right-white.svg'" [iconAlt]="'arrow icon'" [height]="'40px'" [minWidth]="'120px'"
            [width]="'120px'" [active]="unsealStepReady"
            (click)="unsealStepReady && goToLastAssessorStep()"></v8te-active-button>

          <v8te-active-button *ngIf="assessorStep === 2" [buttonText]="'Lancer le scellement du système'"
            [primaryColor]="'#1990FF'" [textPrimaryColor]="'#FFFFFF'" [secondaryColor]="'#1990FF'"
            [textSecondaryColor]="'#FFFFFF'" [iconPosition]="'right'" [border]="'none'"
            [icon]="'assets/arrow-right-white.svg'" [iconAlt]="'arrow icon'" [height]="'40px'" [minWidth]="'120px'"
            [width]="'120px'" [active]="testStepStatus == 'AssessorTestValidated'"
            (click)="testStepStatus == 'AssessorTestValidated' && goToLastAssessorStep()"></v8te-active-button>
        </div>

        <div *ngIf="papCreationStep" class="p-20 flex content-between" id="pap-creation-footer">
          <v8te-active-button [buttonText]="'Enregistrer et quitter'" [primaryColor]="'#FFFFFF'"
            [textPrimaryColor]="'#2B2D67'" [iconPosition]="'left'" [border]="'solid 1px #2B2D67'"
            [icon]="'assets/floppy-icon.svg'" [iconAlt]="'floppy icon'" [height]="'40px'" [minWidth]="'120px'"
            [width]="'120px'"></v8te-active-button>

          <v8te-active-button [buttonText]="'Vérifier mon modèle de PAP'" [primaryColor]="'#1990FF'"
            [textPrimaryColor]="'#FFFFFF'" [secondaryColor]="'#1990FF'" [textSecondaryColor]="'#FFFFFF'"
            [iconPosition]="'right'" [border]="'none'" [icon]="'assets/arrow-right.svg'" [iconAlt]="'arrow icon'"
            (click)="goToVerification()" [height]="'40px'" [minWidth]="'120px'" [width]="'120px'"
            [active]="papVerificationReady"></v8te-active-button>
        </div>
        <div *ngIf="papVerificationStep" class="flex content-between p-20" id="pap-verification-footer">
          <div class="flex align-items-center gap-10">
            <img src="assets/sheet-green-icon.svg" alt="">
            <div>
              <p class="dark-blue bold no-margin">Modifier mon modèle de PAP</p>
              <p class="dark-gray no-margin">
                Toutes les sections ont été validées. Vous pouvez maintenant générer votre document.
              </p>
            </div>
          </div>

          <button *ngIf="!componentValidated" class="disabled-action-button" (click)="confirmPap()">
            <img src="assets/download-file-icon.svg" alt="">
            Générer mon modèle de PAP
          </button>
          <button *ngIf="componentValidated" class="edit-button" (click)="confirmPap()">
            <img src="assets/download-file-icon.svg" alt="">
            Générer mon modèle de PAP
          </button>
        </div>
        <!-- style="border-top: solid 1px #F0F5FF;" -->
      </main>

      <div style="margin-top: 62px; margin-right: 24px;">
        <p class="no-margin dark-gray text-sm">Premier pas</p>
        <p class="no-margin dark-blue bold text-sm">À VOTRE DISPOSITION :</p>
        <div class="flex info-section gap-10 mb-10 mt-20">
          <img src="assets/guide-icon.svg" alt="">
          <div>
            <p class="dark-blue no-margin text-sm">Pour réussir un scrutin</p>
            <p class="light-blue no-margin pointer text-sm" (click)="downloadGuide()">Voir nos guides</p>
          </div>
        </div>

        <div class="flex info-section gap-10 mb-10">
          <img src="assets/docs-icon.svg" alt="">
          <div>
            <p class="dark-blue no-margin text-sm">Pour tout savoir,</p>
            <p class="light-blue no-margin pointer text-sm" (click)="downloadDocuments()">Voir nos documents</p>
          </div>
        </div>

        <div class="flex info-section gap-10 mb-10">
          <img src="assets/support-icon.svg" alt="">
          <div>
            <p class="dark-blue no-margin text-sm">Pour toutes questions,</p>
            <p class="light-blue no-margin pointer text-sm" (click)="contactMail()">support_client&#64;v8te.com</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<vc-loader messageToTheUser="Votre scrutin est en cours de création, cela peut prendre quelques secondes..."
  *ngIf="pollCreationLoader"></vc-loader>
<vc-loader messageToTheUser="Le scrutin de test est en cours de clôture, cela peut prendre quelques secondes..."
  *ngIf="closingAssessorsVoteLoader"></vc-loader>
<transfer-assessors-popup *ngIf="displayChangeAssessor" [pollId]="pollId" [mailToChange]="mailToChange"
  (closeChangeAssessor)="closeChangeMailAssessorPopup($event)"></transfer-assessors-popup>
<single-assessors-relaunch-popup *ngIf="displayResendAssessor" (isClosed)="launchAssessorsRelaunch($event)"
  [isResend]=false [isAssessors]=true [assessorToRelaunch]="assessorToRelaunch">
</single-assessors-relaunch-popup>